import { render } from "./HighscoresButtons.vue?vue&type=template&id=51dcc932"
import script from "./HighscoresButtons.vue?vue&type=script&lang=js"
export * from "./HighscoresButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__